<style>
  #chart {
    height: 300px !important;
  }
</style>

<div id="chart"></div>

<!-- <si-seatsio-seating-chart [config]="configSeatChart"></si-seatsio-seating-chart> -->
